import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Flex, xcss } from '@atlaskit/primitives';
import Lozenge from '@atlaskit/lozenge';

import { AILabsLozenge } from '@atlassian/ai-components';

const titleSpacingStyles = xcss({
	marginRight: 'space.075',
});

export const ItemTitleWithLozenge = ({
	children,
	lozenge,
	useLabsLozenge,
}: {
	children: React.ReactNode;
	lozenge?: React.ReactNode;
	useLabsLozenge?: boolean;
}): React.JSX.Element => (
	<Flex alignItems="center" justifyContent="space-between">
		<Box xcss={titleSpacingStyles}>{children}</Box>
		{useLabsLozenge ? <AILabsLozenge /> : <Lozenge appearance="new">{lozenge}</Lozenge>}
	</Flex>
);
